export default __webpack_public_path__ + "static/media/overcastOne.a107ae6c.jpg";